import React, { useState, useEffect, forwardRef } from 'react';
import {
  createNewCommentInContentByUser,
  deleteCommentByCommentId,
} from 'services/comments';
import { compareDate } from 'helpers/formatDate';
import Comment from 'services/comments/models/comments-interface';
import { User } from 'services/user/models/user-interface';
import ResponseContent from './ResponseContent';
import DeleteIcon from '../../../../assets/icon/delete.png';
import {
  CommentsContentWrapper,
  CommentCardContainer,
  CommentFormContainer,
  CommentBlankBtn,
} from './style';

import UserIcon from 'assets/icon/avatar-branco.svg';
import CommentsIcon from 'assets/icon/icone-comentarios.svg';

interface IComments {
  comments: Comment[];
  lessonId: string;
  reload: () => void;
}
// forwardRef<HTMLDivElement, CommentsContentProps>((props, ref)
const CommentsContent = forwardRef<HTMLDivElement, IComments>(
  ({ comments, lessonId, reload }, ref) => {
    const [commentText, setCommentText] = useState<string>('');
    const [user, setUser] = useState<User>({} as User);
    const [deleteComment, setDeleteComment] = useState<String>('');

    useEffect(() => {
      const user = JSON.parse(localStorage.getItem('exeltis-user') as string);

      setUser(user);
    }, []);

    const handleCreateNewComment = async (
      comment: string,
      id: string,
      response_id: string,
    ): Promise<void> => {
      if (!comment || !id) {
        return;
      }

      const data = {
        description: comment,
        reference_id: id,
        comment_reference_id: response_id !== '' ? response_id : undefined,
      };

      await createNewCommentInContentByUser(data).then(response => {
        if (response) {
          reload();
        }
      });
    };

    const handleDeleteComment = async (comment_id: string) => {
      setDeleteComment(comment_id);
      await deleteCommentByCommentId(comment_id);
    };

    const isAdmin = user?.roles?.includes('Admin');
    return (
      <CommentsContentWrapper ref={ref}>
        <div className="comments-title">
          <h1>Envie seu comentário</h1>
          <span>
            {comments && comments?.length > 1
              ? comments?.length + ' comentários'
              : comments?.length + ' comentário'}
          </span>
        </div>

        <CommentFormContainer isResponseComponent={false}>
          <div className="input-container">
            <textarea
              placeholder="Faça um comentário"
              value={commentText}
              onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) =>
                setCommentText(event.target.value)
              }
              rows={5}
            />
          </div>

          <div className="btns-container">
            <CommentBlankBtn
              onClick={() => handleCreateNewComment(commentText, lessonId, '')}
            >
              <img src={CommentsIcon} alt="comments" />
              Enviar comentário
            </CommentBlankBtn>
          </div>
        </CommentFormContainer>

        {comments && comments.length
          ? comments.map((comment, index, array) => {
              if (deleteComment === comment?.comment_id) {
                return null;
              } else {
                return (
                  <CommentCardContainer key={index}>
                    <div className="container">
                      <div className="avatar-container">
                        <img
                          src={
                            comment.user_avatar_url
                              ? comment?.user_avatar_url
                              : UserIcon
                          }
                          alt="person"
                          className="profile-avatar"
                        />
                      </div>
                      <div className="comment-card">
                        <div className="title">
                          <h2>{comment?.username}</h2>

                          <span>{compareDate(comment?.created_at)}</span>
                          {isAdmin && (
                            <button
                              onClick={() =>
                                handleDeleteComment(comment?.comment_id)
                              }
                            >
                              <img src={DeleteIcon} alt="Excluir" />
                            </button>
                          )}
                          {!isAdmin && comment?.user_id == user?.user_id && (
                            <button
                              onClick={() =>
                                handleDeleteComment(comment?.comment_id)
                              }
                            >
                              <img src={DeleteIcon} alt="Excluir" />
                            </button>
                          )}
                        </div>

                        <p>{comment?.description}</p>
                      </div>
                    </div>

                    <ResponseContent
                      comment={comment}
                      handleCreateNewComment={handleCreateNewComment}
                      lessonId={lessonId}
                      user={user}
                    />

                    {array.length !== index + 1 ? (
                      <div className="spacer"></div>
                    ) : null}
                  </CommentCardContainer>
                );
              }
            })
          : null}
      </CommentsContentWrapper>
    );
  },
);

export default CommentsContent;
